import {Component, ElementRef, HostListener, OnInit} from '@angular/core';
import {UcaNavigationService} from "../../services/uca-navigation.service";
import {ParamService} from "../../services/param.service";
import {GameService} from "../../services/game/game.service";
import { AuthService } from '../../services/auth.service';



declare var $: any;


@Component({
    selector: 'left-navigation',
    templateUrl: './left-navigation.component.html',
    styleUrls: ['./left-navigation.component.scss']
})
export class LeftNavigationComponent implements OnInit {
    KEYCODE_TAB: number = 9;
    leftNavOptions: any;
    leftNavOptionsList = [];
    banner: any;
    displayBanner: any;
    currentEnvironment: any;

    constructor(private hostElement: ElementRef, private ucaNavigationService: UcaNavigationService,
                private paramService: ParamService, private gameService: GameService, private authService: AuthService) {
    }

    ngOnInit() {
        this.banner = this.paramService.banner;
        this.displayBanner = this.paramService.displayBanner;
        this.currentEnvironment = this.gameService.getEnvironment();
        this.initSubscribes();
        if(this.leftNavOptionsList.length === 0) {
            this.ucaNavigationService.getLeftNavItems(this.banner, this.currentEnvironment);
        }
    }

    initSubscribes() {
        this.ucaNavigationService.populateUcaNavigationSource$.subscribe(async (value) => {
            if (this.authService.checkB2B()) {
                this.leftNavOptionsList = [
                    { openPageMenu: 'false', menuLink: '/foru/coupons-deals.html', menuText: 'Deals+' },
                    { openPageMenu: 'false', menuLink: '/rewards/dashboard', menuText: 'Rewards' },
                    { openPageMenu: 'false', menuLink: '/foru/program-details.html', menuText: 'Program Details' },
                    { openPageMenu: 'false', menuLink: '/games/game-grid', menuText: 'Play & Earn' },
                    { openPageMenu: 'false', menuLink: '/rewards/partners', menuText: 'Partners offers' }
                ];
                this.leftNavOptions = { titleText: this.displayBanner + ' for U' };
            } else {
                // Await so that discovery item is deleted from `value` BEFORE the for..in loop runs
                await this.getExperimentByIDAndRemoveLeftNavDiscovery(value);
                if (value && value.root && value.root.responsivegrid && value.root.responsivegrid.left_navigation.staticMenuItems) {
                    for (const key in value.root.responsivegrid.left_navigation.staticMenuItems) {
                        value.root.responsivegrid.left_navigation.staticMenuItems[key].menuLink = value.root.responsivegrid.left_navigation.staticMenuItems[key].menuLink.replace(/\(banner\)/g, this.banner);
                        if (value.root.responsivegrid.left_navigation.staticMenuItems[key].menuLink.indexOf('games') >= 0) {
                            value.root.responsivegrid.left_navigation.staticMenuItems[key].menuLink = '/games/game-grid';
                        }
    
                        this.leftNavOptionsList.push(value.root.responsivegrid.left_navigation.staticMenuItems[key]);
                    }
                    this.leftNavOptions = value.root.responsivegrid.left_navigation;
                    this.leftNavOptions.titleText = this.leftNavOptions.titleText.replace(/\(banner4U\)/g, this.displayBanner);
                }
            }

        });
    }
    
    //get experiment details for ACIP548280 and determine whether to show/hide discovery item based on experiment group and eligibility
    getExperimentByIDAndRemoveLeftNavDiscovery(leftNavJson): Promise<void> {
        var EXPERIMENT_ID = 'ACIP548280';
        var sdk = window['AB'] && window['AB']?.experimentation;
        const enableSavingsHubByBanner = window['SWY']?.CONFIGSERVICE?.featureToggleConfig?.enableSavingsHub;
        if (!sdk || typeof sdk.getExperimentByID !== 'function' || !enableSavingsHubByBanner) {
            this.removeDiscoveryItem(leftNavJson);
            return Promise.resolve();
      }

      return sdk?.getExperimentByID(EXPERIMENT_ID, false)
        .then((response) => {
          var features = (response && Array.isArray(response.features)) ? response.features : [];
          var feature = features.find(function (f) { return f && f.featureId === EXPERIMENT_ID; }) || null;

          if (!feature || !feature.eligible) {
            this.removeDiscoveryItem(leftNavJson);
            return;
          }
            switch (feature.group) {
                case 'A':
                this.removeDiscoveryItem(leftNavJson);
                break;
                case 'B':
                break;
                case 'C':
                break;
                default:
                this.removeDiscoveryItem(leftNavJson);
                break;
            }

        }).catch(() => {
          this.removeDiscoveryItem(leftNavJson);
        });
    }

    removeDiscoveryItem(leftNavJson) {
        const menuItems = leftNavJson?.root?.responsivegrid?.left_navigation?.staticMenuItems;
        if (menuItems) {
            for (const key in menuItems) {
                if (menuItems[key]?.menuLink?.indexOf('discovery') >= 0) {
                    delete menuItems[key];
                }
            }
        }
    }

    @HostListener("keydown", ["$event"])
    onKeyDown(e: KeyboardEvent): any {
        if (window.innerWidth <= 990) {
            if (e.key === 'Tab' || e.keyCode === this.KEYCODE_TAB) {
                let focusableEls = this.hostElement.nativeElement;
                let modalContent = $(focusableEls).find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), input[type="ul"]:not([disabled]), input[type="li"]:not([disabled])');
                var firstFocusableEl = modalContent.first()[0];
                var lastFocusableEl = modalContent.last()[0];

                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableEl) {
                        lastFocusableEl.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastFocusableEl) {
                        firstFocusableEl.focus();
                        e.preventDefault();
                    }
                }
            }
        }
    }

}
